import React, { FC } from 'react';
import { Row } from 'antd';
// import { useReactiveVar } from '@apollo/client';
// import { selectedProcedures } from 'apollo/cache';
import { AvailableProcedures, OperationalCosts } from 'apollo/types';
import baseProceduresInfo from 'utils/proceduresInfo';
import currencyFormatter from 'utils/currencyFormatter';
import styles from './OperationalCostsDetails.module.scss';

interface OperationalCostsDetailsProps {
  operationalCosts?: OperationalCosts;
}

const OperationalCostsDetails: FC<OperationalCostsDetailsProps> = (
  props: OperationalCostsDetailsProps,
) => {
  const { operationalCosts } = props;
  // const selectedProceduresInfo = useReactiveVar(selectedProcedures);

  const translateProcedureName = (name: AvailableProcedures) => {
    const procedureInfo = baseProceduresInfo.find(
      (procedure) => procedure.key === name,
    );
    return procedureInfo?.name;
  };

  return (
    <div className={styles.PopoverContainer}>
      {operationalCosts ? (
        <>
          {operationalCosts.procedures.map((procedure) => (
            <Row justify="space-between" key={procedure.name}>
              <p>{translateProcedureName(procedure.name)}</p>
              <p>
                {procedure.selected
                  ? currencyFormatter.format(procedure.price)
                  : '-'}
              </p>
            </Row>
          ))}
        </>
      ) : (
        <>
          {/* {selectedProceduresInfo.map((procedure) => (
            <Row justify="space-between" key={procedure.name}>
              <p>{procedure.name}</p>
              <p>
                {procedure.selected ? currencyFormatter.format(procedure.price) : '-'}
              </p>
            </Row>
          ))} */}
        </>
      )}
    </div>
  );
};

OperationalCostsDetails.defaultProps = {
  operationalCosts: undefined,
};

export default OperationalCostsDetails;
